import React from 'react';
import ReactDom from 'react-dom';

import Root from './Root';
import App from './components/App';
import {getInitialFormState} from './utils';

import './styles.css';


const initialState = getInitialFormState();


ReactDom.render(
    <Root initialState={initialState}>
        <App />
    </Root>,
    document.getElementById('otp-ui')
);
